import React from 'react';
import loadable from '@loadable/component';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "extra" */ './tracking-settings')
);

const Loader = props => <LoadableComponent {...props} />;
export default Loader;
